module.exports = __webpack_public_path__ + "img/sort-icon-4.ddbac650.png";